module.exports={
  "headerLogoTooltipText": "Back to dashboard",
  "exportAsImage": "Export as image",
  "takeATour": "Take a tour",
  "linkToShare": "Link to share ",
  "myAccount": "My Account",
  "userAvatar": "User Avatar",
  "signOut": "Sign Out",
  "notAccessible": "(not accessible when project is private)",
  "logIn": "Log in",
  "signUp": "Sign up",
  "findOpportunities": "Find opportunities",
  "findNewOpportunities": "Find new opportunities",
  "findAreasByCriteria": "Find areas by criteria",
  "identifyLocationsBasedOnCriteriaYouSpecify": "Identify locations based on criteria you specify.",
  "findFacilities": "Find facilities",
  "findFacilitiesThatMatchSpecificCriteria": "Find facilities that match specific criteria.",
  "saveMap": "Save map"
}
